// src/components/PrivateRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAdminSession from "../hooks/useAdminSession.js";
import AdminStatus from "./AdminStatus.jsx";

// Access is decided by the server-side session (admin API), never by
// localStorage. Protected data is additionally checked on every API request.
export default function PrivateRoute({ children }) {
  const status = useAdminSession();
  const location = useLocation();

  if (status === "checking") {
    return <AdminStatus message="Checking access…" />;
  }

  if (status !== "authenticated") {
    return (
      <Navigate
        to={`/private/login?next=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }

  return children;
}
